<div class="content">

  <!-- Begin dashboard -->
  <div class="container-fluid overflow-auto pt-5 mt-5" style="max-height: 860px;">

    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Add Header</h1>
    </div>

    <!-- Content Row -->
    <div class="row">
      <div class="col-xl-12 col-md-12 mb-2">
        <div class="card border-left-primary shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-primary  mb-1">
                  <form [formGroup]="headerForm" (ngSubmit)="onRegister()">
                    <div formArrayName="headers">
                      <div class="row" *ngFor="let header of headers.controls; let i = index" [formGroupName]="i">

                        <div class="col-xl-4 col-md-4">
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Header Name</mat-label>
                            <input matInput formControlName="name" placeholder="Enter Header Name">
                            <mat-error *ngIf="header.get('name')?.hasError('required')">This field is required!</mat-error>
                            <mat-error *ngIf="header.get('name')?.hasError('minlength')">Minimum 3 characters required!</mat-error>
                          </mat-form-field>
                        </div>

                        <!-- Delete button -->
                        <div class="col-md-2 d-flex align-items-center">
                          <button type="button" mat-mini-fab color="warn" (click)="removeHeader(i)" *ngIf="headers.length > 1">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Add new header button -->
                    <button type="button" mat-raised-button color="accent" (click)="addHeader()">+ Add Header</button>

                    <div class="mt-3">
                      <button type="button" routerLink="/report" class="btn btn-secondary float-end waves-effect waves-light">Cancel</button>
                      <button *ngIf="!headerForm" class="btn btn-outline-light btn-lg px-5 float-right" mat-raised-button color="primary" type="submit" [routerLink]="['/report']" [disabled]="!headerForm.valid">Register </button>
                      <button *ngIf="headerForm" class="btn btn-outline-light btn-lg px-5 float-right" mat-raised-button color="primary" type="submit" [routerLink]="['/report']" [disabled]="!headerForm.valid">Update </button>

                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
